<template>
  <v-card>
    <v-toolbar color="white" elevation="0">
       <div class="col-12"><h2>Question/Answer</h2></div>
      <template v-slot:extension>
        <v-tabs v-model="tabs" centered>
          <v-tab dark>
            <label class="primary_whiten--text"> Questions </label></v-tab
          >
          <v-tab class="orange--text">Answer</v-tab>
        </v-tabs>
      </template>
    </v-toolbar>
    <v-divider> </v-divider>

    <v-tabs-items v-model="tabs">
      <v-tab-item>
        <v-row>
          <v-col
            cols="6"
            sm="6"
            md="6"
            v-for="(item) in allQuestions"
            :key="item.id"
          >
          <question-list :id="item.userId" :question="item.question" />
          </v-col>
        </v-row>
      </v-tab-item>

      <v-tab-item>
        <v-row>
          <v-col
            cols="6"
            sm="6"
            md="6"
            v-for="(item, index) in allAnswers"
            :key="index"
          >
            <answer-list :answer="item.answer" :question="item.question" />
          </v-col>
        </v-row>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template> 

<script>
import { mapFields } from "vuex-map-fields";
import { mapActions } from "vuex";
import QuestionList from "../components/QuestionList";
import AnswerList from "../components/AnswerList";

export default {
  async created() {
    await this.fetchAllQuestions();
    await this.fetchAllAnswers();
  },
  components: {
  QuestionList,
  AnswerList,
},
  computed: {
  ...mapFields("faq", ["allQuestions", "allAnswers"]),
  },
  data() {
    return {
      tab: null,
      tabs: null,
      show: false,
    };
  },
    methods: {
    ...mapActions("faq", ["fetchAllQuestions", "fetchAllAnswers"]),
    }
}
</script>